import RolesInput from './roles-input';

export default RolesInput;
